const listOfMedication = {
  Tablet: "Tablet",
  Injectable: "Injectable",
  CapTab: "Cap/Tab",
  EyeDrop: "Eye Drop",
  Capsule: "Capsule",
  NebulisingSolution: "Nebulising Solution",
  Inhaler: "Inhaler",
  Each: "Each",
  NasalSpray: "Nasal Spray",
  Ointment: "Ointment",
  Gel: "Gel",
  Lotion: "Lotion",
  Cream: "Cream",
  Suppository: "Suppository",
  OralGel: "Oral Gel",
  Shampoo: "Shampoo",
  EarDrop: "Ear Drop",
  TopicalSolution: "Topical Solution",
  Mouthwash: "Mouthwash",
  EyeOintment: "Eye Ointment",
  EyeEarDrop: "Eye/Ear Drop",
  Powder: "Powder",
  Pessary: "Pessary",
  Lozenges: "Lozenges",
  OralSolution: "Oral Solution",
  Infusion: "Infusion",
  Enema: "Enema",
  Syrup: "Syrup",
  Patch: "Patch",
  Spray: "Spray",
  OralDrop: "Oral Drop",
  Dressing: "Dressing",
  NasalDrop: "Nasal Drop",
  Emulsion: "Emulsion",
  Liniment: "Liniment",
  Paste: "Paste",
  VaginalCream: "Vaginal Cream",
  IrrigationSolution: "Irrigation Solution",
  EyeGel: "Eye Gel",
};

const listOfMeasurement = {
  mg: "mg",
  application: "application",
  units: "unit(s)",
  mcg: "mcg",
  drops: "drop(s)",
  tablets: "tablet(s)",
  mL: "mL",
  puffs: "puff(s)",
  sprays: "spray(s)",
  suppository: "suppository",
  mmol: "mmol",
  g: "g",
  lozenges: "lozenge(s)",
  mcg_hr: "mcg/hr",
  enema: "enema",
  sachets: "sachet(s)",
  each: "each",
  pessary: "pessary",
  capsules: "capsule(s)",
  patch: "patch",
};
const medicineTypes = {
  tablet: "Tablet",
  capsule: "Capsule",
  liquid: "Liquid",
  cream: "Cream",
  inhalation: "Inhalation",
};
export { listOfMeasurement, listOfMedication, medicineTypes };
